
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.6021 5.59786C11.6021 4.64262 11.2226 3.72649 10.5472 3.05103C9.87169 2.37556 8.95556 1.99609 8.00031 1.99609C7.04506 1.99609 6.12894 2.37556 5.45348 3.05103C4.77801 3.72649 4.39854 4.64262 4.39854 5.59786C4.39854 9.79993 2.59766 11.0005 2.59766 11.0005H13.403C13.403 11.0005 11.6021 9.79993 11.6021 5.59786Z","stroke":"#10001F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.03796 13.4019C8.93242 13.5838 8.78094 13.7348 8.59868 13.8398C8.41642 13.9448 8.20978 14 7.99945 14C7.78912 14 7.58248 13.9448 7.40022 13.8398C7.21796 13.7348 7.06648 13.5838 6.96094 13.4019","stroke":"#10001F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    